var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kraus-small-tooltip",style:({opacity: _vm.opacity, top: (this.opacity > 0 ? 150 : -100) + 'px'})},[_c('div',{staticClass:"icon"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }